import { API_BASE, getAuthHeaders, fetchJson } from './client';

export const portal = {
  getClient: () => fetchJson<any>('/portal/client'),
  updateClient: (clientId: string, data: { contactEmail?: string; contactName?: string; billingEmail?: string; billingStreet?: string; billingCity?: string; billingState?: string; billingZip?: string; billingCountry?: string; notes?: string }) =>
    fetchJson<any>(`/portal/clients/${clientId}`, { method: 'PUT', body: JSON.stringify(data) }),
  uploadLogo: (clientId: string, logoData: string) =>
    fetchJson<{ logoPath: string }>(`/portal/clients/${clientId}/logo`, { method: 'POST', body: JSON.stringify({ logoData }) }),
  removeLogo: (clientId: string) =>
    fetchJson(`/portal/clients/${clientId}/logo`, { method: 'DELETE' }),
  getProjects: () => fetchJson<any[]>('/portal/projects'),
  getProject: (id: string) => fetchJson<any>(`/portal/projects/${id}`),
  getMembers: (clientId: string) =>
    fetchJson<{ members: any[]; memberLimit: number | null }>(`/portal/clients/${clientId}/members`),
  getPendingUsers: (clientId: string) =>
    fetchJson<any[]>(`/portal/clients/${clientId}/pending-users`),
  approveUser: (clientId: string, userId: string) =>
    fetchJson(`/portal/clients/${clientId}/users/${userId}/approve`, { method: 'POST' }),
  rejectUser: (clientId: string, userId: string) =>
    fetchJson(`/portal/clients/${clientId}/users/${userId}/reject`, { method: 'POST' }),
  updateMemberRole: (clientId: string, userId: string, role: string) =>
    fetchJson(`/portal/clients/${clientId}/users/${userId}/role`, { method: 'PUT', body: JSON.stringify({ role }) }),
  updateProfile: (data: { name?: string }) =>
    fetchJson<any>('/portal/profile', { method: 'PUT', body: JSON.stringify(data) }),
  uploadProfilePhoto: async (file: File): Promise<{ profilePhotoPath: string }> => {
    const formData = new FormData();
    formData.append('photo', file);
    const authHeaders = await getAuthHeaders();
    const res = await fetch(`${API_BASE}/portal/profile/photo`, {
      method: 'POST',
      headers: { ...authHeaders },
      body: formData,
    });
    if (!res.ok) throw new Error('Upload failed');
    return res.json();
  },
  removeProfilePhoto: () =>
    fetchJson('/portal/profile/photo', { method: 'DELETE' }),

  // ─── Client Admin Management ────────────────────────────────────────────
  getEnrollment: (clientId: string) =>
    fetchJson<{ enrollmentCode: string | null; enrollmentEnabled: boolean; autoApproveMode: string; autoApproveDomains: string | null }>(
      `/portal/clients/${clientId}/enrollment`
    ),
  updateEnrollment: (clientId: string, data: { enrollmentEnabled?: boolean; autoApproveMode?: string; autoApproveDomains?: string }) =>
    fetchJson<{ enrollmentCode: string | null; enrollmentEnabled: boolean; autoApproveMode: string; autoApproveDomains: string | null }>(
      `/portal/clients/${clientId}/enrollment`,
      { method: 'POST', body: JSON.stringify(data) }
    ),
  regenerateEnrollmentCode: (clientId: string) =>
    fetchJson<{ enrollmentCode: string }>(
      `/portal/clients/${clientId}/enrollment/regenerate-code`,
      { method: 'POST' }
    ),
  addUser: (clientId: string, data: { email: string; name: string; password: string; clientRole?: string }) =>
    fetchJson<{ success: boolean; userId: string; linked: boolean }>(
      `/portal/clients/${clientId}/add-user`,
      { method: 'POST', body: JSON.stringify(data) }
    ),
  resetMemberPassword: (clientId: string, userId: string, newPassword: string) =>
    fetchJson<{ success: boolean }>(
      `/portal/clients/${clientId}/users/${userId}/reset-password`,
      { method: 'POST', body: JSON.stringify({ newPassword }) }
    ),
  bulkAddUsers: (clientId: string, users: Array<{ email: string; password: string; name?: string; orgRole?: string }>) =>
    fetchJson<{ created: number; failed: number; results: Array<{ email: string; success: boolean; error?: string }> }>(
      `/portal/clients/${clientId}/bulk-add-users`,
      { method: 'POST', body: JSON.stringify({ users }) }
    ),
};
